import { useMemo, useState } from "react";
import { viewerReviews } from "@/mocks/nanny";

const filters = [
  { id: "all", label: "全部" },
  { id: "电影版", label: "电影版" },
  { id: "电视剧版", label: "电视剧版" },
  { id: "短剧版", label: "短剧版" },
];

function Stars({ value }: { value: number }) {
  return (
    <span className="flex items-center gap-0.5" aria-label={`评分 ${value} 分`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={i < value ? "ri-star-fill text-primary-500 text-sm" : "ri-star-line text-background-400 text-sm"}
        ></i>
      ))}
    </span>
  );
}

export default function Reviews() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () => (active === "all" ? viewerReviews : viewerReviews.filter((r) => r.tag === active)),
    [active],
  );

  const average = useMemo(() => {
    const sum = viewerReviews.reduce((acc, r) => acc + r.rating, 0);
    return (sum / viewerReviews.length).toFixed(1);
  }, []);

  return (
    <section id="reviews" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
            <div>
              <span className="text-primary-600 font-label text-sm tracking-[0.2em] uppercase">Reviews</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">观众口碑</h2>
            </div>
            <div className="flex items-center gap-4 bg-background-100 border border-background-200 rounded-lg px-5 py-3">
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">{average}</span>
              <span className="text-sm text-foreground-600 leading-snug">
                综合评分
                <br />
                基于 {viewerReviews.length} 条观众短评
              </span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 mb-6 md:mb-8">
            {filters.map((f) => (
              <button
                key={f.id}
                type="button"
                onClick={() => setActive(f.id)}
                className={`px-4 py-2 rounded-full text-sm cursor-pointer transition-colors whitespace-nowrap ${
                  active === f.id
                    ? "bg-accent-500 text-background-50"
                    : "bg-background-100 text-foreground-700 border border-background-200 hover:border-accent-300"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {list.map((r) => (
              <blockquote
                key={r.user}
                className="bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <Stars value={r.rating} />
                  <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                    {r.tag}
                  </span>
                </div>
                <p className="mt-4 text-foreground-700 text-sm leading-relaxed flex-1">“{r.content}”</p>
                <footer className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-2">
                    <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center">
                      <i className="ri-user-line text-xs"></i>
                    </span>
                    {r.user}
                  </span>
                  <time>{r.date}</time>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}